module.exports = __webpack_public_path__ + "static/media/fWebsites.0c452308.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/fWebsites.jpg
// module id = 851
// module chunks = 14